import axios from "axios"
import config from "config"

export default class Api {
  constructor(key, analytics) {
    this.analytics = analytics
    this.instance = axios.create({
      baseURL: config.API_URL,
      timeout: 60000,
      // headers: { "X-Player-Key": key },
    })

    // if (process.env.NODE_ENV === "development") {
    //   const mock = require("utils/mocks/mockApi")
    //   mock.default(this.instance, 0)
    // }
  }

  getPlaylist({ publication, url, page }) {
    const params = { publisher: publication, url, page }
    return this.instance.get("playlist", { params }).then((response) => {
      const playlist = response.data.result

      if (!playlist.stories.length) {
        this.analytics.trackNoStoriesEvent(params)
      }

      return playlist
    })
  }

  getPlayerConfig = (publication) => this.instance.get(`settings?publisher=${publication}`).then((response) => response.data.result)
}



// WEBPACK FOOTER //
// ./src/services/api.js